import $ from "jquery";
$(".accordion").on("click", function () {
  $(".accordion").removeClass("active");
  $(this).addClass("active");
  $(this)
    .next()
    .find("img")
    .each(function () {
      var imgsrc = $(this).attr("acc-src");
      $(this).attr("src", imgsrc);
    });
  var ScrollHeight = $(this).next().prop("scrollHeight");
  if (ScrollHeight < 350) {
    ScrollHeight = 490;
  }

  if ($(this).next().css("max-height") != "0px") {
    $(this).next().css("max-height", "0px");
  } else {
    $(this)
      .next()
      .css("max-height", ScrollHeight + "px");
  }
});
